// extracted by mini-css-extract-plugin
module.exports = {"pageStyle":"ProjectEditPopup_pageStyle__3_Jng","dialogCard":"ProjectEditPopup_dialogCard__308C7"};